module.exports = __webpack_public_path__ + "static/media/icon-redo-active.e9ad5a3f.svg";